// @flow
import type { State } from '../types';

const subStateSelector = (state: State) => state.users;

export const statusSelector = (state: State) => {
    const subState = subStateSelector(state);
    return subState.status;
};

export const isLoadingSelector = (state: State) => {
    const status = statusSelector(state);
    return status.isLoading;
};

export const usersListSelector = (state: State) => {
    const subState = subStateSelector(state);
    return subState.list;
};

export const usersEntitiesSelector = (state: State) => {
    const subState = subStateSelector(state);
    return subState.entities;
};

export const makeUserEntitySelector = (id: string) => (state: State) => {
    const entities = usersEntitiesSelector(state);
    return entities && entities[id];
};